import { render, staticRenderFns } from "./ModalAddGuardian.vue?vue&type=template&id=724d8c4a"
import script from "./ModalAddGuardian.vue?vue&type=script&lang=js"
export * from "./ModalAddGuardian.vue?vue&type=script&lang=js"
import style0 from "./ModalAddGuardian.vue?vue&type=style&index=0&id=724d8c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports